export const msalConfig = {
    auth: {
        clientId: import.meta.env.VITE_MSAL_CONFIG_CLIENTID,
        authority: 'https://login.microsoftonline.com/common/'
    },
    cache: {
        cacheLocation: "sessionStorage"
    }
}